import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

export type AspectRatio = '1:1' | '16:9' | '9:16' | '4:3' | '3:4'

interface AspectRatioPickerProps {
  value: AspectRatio
  onChange: (v: AspectRatio) => void
  options?: AspectRatio[]
}

const DEFAULT_OPTIONS: AspectRatio[] = ['1:1', '16:9', '9:16']

export function AspectRatioPicker({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
}: AspectRatioPickerProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>Aspect ratio</Label>
      <div className="flex gap-1.5 flex-wrap">
        {options.map((ratio) => (
          <Button
            key={ratio}
            size="sm"
            variant={value === ratio ? 'default' : 'outline'}
            onClick={() => onChange(ratio)}
            className="text-xs px-3"
          >
            {ratio}
          </Button>
        ))}
      </div>
    </div>
  )
}
